import label from "@/lang/StaticLabels.js";

// PSCMS Navbar  - تدارکات و خرید  -----------------------------------------------
let navItems = [
  {
    title: label.modules.pscms,
    icon: "mdi-map-marker-radius",
    to: false,
  },
  {
    to: "PSCMSDashboard",
    label: label.menu.dashboard,
    icon: "pi pi-home",
    active: false,
    subItems: false,
    divider: true,
  },
  {
    to: null,
    label: label.menu.baseInformation,
    icon: "pi pi-database",
    active: false,
    subItems: [
      {
        to: "PSCMSBuyType",
        label: label.menu.buyType,
        metaLabel: label.page.buyType,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSCMSBuyAddMinusList",
        label: label.menu.buyAddMinus,
        metaLabel: label.page.buyAddMinus,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSCMSSystemSetting",
        label: label.menu.settings,
        metaLabel: label.page.scmsSetting,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
  {
    to: null,
    label: label.menu.operation,
    icon: "mdi-wrench-outline",
    active: false,
    subItems: [
      {
        to: null,
        label: label.menu.buyRequest,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PSCMSAddBuyRequest",
            label: label.menu.addBuyRequest,
            metaLabel: label.page.addBuyRequest,
            icon: "mdi-circle-small",
          },
          {
            to: "PSCMSBuyRequestList",
            label: label.menu.buyRequestList,
            metaLabel: label.page.buyRequest,
            icon: "mdi-circle-small",
          },
          {
            to: "PSCMSBuyRequestCartable",
            label: label.menu.buyRequestCartable,
            metaLabel: label.page.buyRequestCartable,
            icon: "mdi-circle-small",
          },
          {
            to: "PSCMSBuyer",
            label: label.menu.buyer,
            metaLabel: label.page.buyer,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.buyFactor,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PSCMSBuyFactorAdd",
            label: label.menu.addBuyFactor,
            metaLabel: label.page.addBuyFactor,
            icon: "mdi-circle-small",
          },
          {
            to: "PSCMSBuyFactorList",
            label: label.menu.buyFactorList,
            metaLabel: label.page.buyFactor,
            icon: "mdi-circle-small",
          },
          {
            to: "PSCMSBuyFactorConfirmCartable",
            label: label.menu.buyFactorConfirmCartable,
            metaLabel: label.page.buyFactorConfirmCartable,
            icon: "mdi-circle-small",
          },
          {
            to: "PSCMSSortBuyFactor",
            label: label.menu.sortBuyFactor,
            metaLabel: label.page.sortBuyFactor,
            icon: "mdi-circle-small",
          },
          {
            to: "PSCMSBuyFactorGroupReceipt",
            label: label.menu.factorGroupReceipt,
            metaLabel: label.page.buyFactorGroupReceipt,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.returnBuyFactor,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PSCMSReturnBuyFactorAdd",
            label: label.menu.addReturnBuyFactor,
            metaLabel: label.page.addReturnBuyFactor,
            icon: "mdi-circle-small",
          },
          {
            to: "PSCMSReturnBuyFactorList",
            label: label.menu.buyReturnFactorList,
            metaLabel: label.page.returnBuyFactor,
            icon: "mdi-circle-small",
          },
          {
            to: "PSCMSReturnBuyFactorConfirmCartable",
            label: label.menu.buyReturnConfirmCartable,
            metaLabel: label.page.buyReturnConfirmCartable,
            icon: "mdi-circle-small",
          },
          {
            to: "PSCMSReturnBuyFactorGroupDraft",
            label: label.menu.factorGroupDraft,
            metaLabel: label.page.returnBuyFactorGroupDraft,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.managementCartable,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PSCMSManagementCartableBuyFactor",
            label: label.menu.buyFactor,
            metaLabel: label.page.managementCartableBuy,
            icon: "mdi-circle-small",
          },
          {
            to: "PSCMSManagementCartableBuyReturn",
            label: label.menu.buyReturn,
            metaLabel: label.page.managementCartableBuyReturn,
            icon: "mdi-circle-small",
          },
          {
            to: "PSCMSManagementCartableRequestBuy",
            label: label.menu.buyRequest,
            metaLabel: label.page.managementCartableRequestBuy,
            icon: "mdi-circle-small",
          },
        ],
      },
    ],
  },
  {
    to: null,
    label: label.menu.reports,
    icon: "mdi-chart-bar-stacked",
    active: false,
    subItems: [
      {
        to: null,
        label: label.menu.other,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PSCMSLatestBuyPriceOfCommodity",
            label: label.menu.latestBuyPriceOfCommodity,
            metaLabel: label.page.latestBuyPriceOfCommodity,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.comprehensiveReports,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PSCMSFactorComprehensiveReports",
            label: label.menu.factor,
            metaLabel: label.page.factorComprehensiveReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PSCMSCommodityComprehensiveReports",
            label: label.menu.commodity,
            metaLabel: label.page.commodityComprehensiveReport,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.monthlyPurchaseReport,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PSCMSBuySomeCommodity",
            label: label.menu.buySomeCommodity,
            metaLabel: label.page.buySomeCommodity,
            icon: "mdi-circle-small",
          },
          {
            to: "PSCMSBuyFinancialCommodity",
            label: label.menu.buyFinancialCommodity,
            metaLabel: label.page.buyFinancialCommodity,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: "PSCMSBuyReportBySuppliers",
        label: label.menu.buyReportBySuppliers,
        metaLabel: label.page.buyReportBySuppliers,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
];

export default navItems;
